import request from '@/utils/request';

export function queryVendor(params) {
  return request({
    url: '/product/category/mapping/queryVendor',
    method: 'get',
    params,
    baseURL: process.env.VUE_APP_REST_API
  })
}

export function queryVendorList() {
  return request({
    url: `/sc-merchant-common/v2/vendor/list/nameBox/excludeSeller`,
    method: 'post',
    data: {
      needChildVendorFlag: true,
    },
  });
}

export function queryVendorListRF() {
  return request({
    url: `/sc-merchant-common/v2/vendor/list/nameBox/excludeSeller/regionFilter`,
    method: 'post',
    data: {
      needChildVendorFlag: true,
    },
  });
}

export function queryPage(params) {
  return request({
    url: '/product/category/mapping/queryPage',
    method: 'get',
    params,
    baseURL: process.env.VUE_APP_REST_API
  })
}

export function categorySave(data) {
  return request({
    url: '/product/category/mapping/save',
    method: 'post',
    data,
    baseURL: process.env.VUE_APP_REST_API
  })
}

export function categoryDelete(apiCategoryMapId) {
  return request({
    url: '/product/category/mapping/delete/' + apiCategoryMapId,
    method: 'delete',
    baseURL: process.env.VUE_APP_REST_API
  })
}

export function categoryInitialize(apiConfigurationId) {
  return request({
    url: '/product/category/mapping/initialize/' + apiConfigurationId,
    method: 'post',
    baseURL: process.env.VUE_APP_REST_API
  })
}

export function categoryTemplate() {
  return request({
    url: '/product/category/mapping/template',
    method: 'get',
    baseURL: process.env.VUE_APP_REST_API,
    responseType: "blob"
  })
}

export function categoryUpload(data) {
  return request({
    url: '/product/category/mapping/upload',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    baseURL: process.env.VUE_APP_REST_API
  })
}

export function categoryError(params) {
  return request({
    url: '/product/category/mapping/down/error',
    method: 'get',
    params,
    baseURL: process.env.VUE_APP_REST_API,
    responseType: "blob"
  })
}

export function getCategory(params) {
  return request({
    url: '/basic-backend/category/tree',
    method: 'get',
    params,
  })
}

// brand mapping pass
export function getBrandMappingPassList(data) {
  return request({
    url: '/basic-backend/brand/pass/mapping/list',
    method: 'post',
    data,
  })
}

export function addBrandMappingPass(data) {
  return request({
    url: '/basic-backend/brand/pass/mapping',
    method: 'post',
    data,
  })
}

export function delBrandMappingPass(data) {
  return request({
    url: '/basic-backend/brand/pass/mapping',
    method: 'delete',
    data,
  })
}

// brand mapping block
export function getBrandMappingBlockList() {
  return request({
    url: '/basic-backend/brand/block/mapping/list',
    method: 'post',
  })
}

export function addBrandMappingBlock(data) {
  return request({
    url: '/basic-backend/brand/block/mapping',
    method: 'post',
    data,
  })
}

export function delBrandMappingBlock(data) {
  return request({
    url: '/basic-backend/brand/block/mapping',
    method: 'delete',
    data,
  })
}

// season mapping pass
export function getSeasonMappingPassList(data) {
  return request({
    url: '/basic-backend/season/pass/mapping/list',
    method: 'post',
    data,
  })
}

export function addSeasonMappingPass(data) {
  return request({
    url: '/basic-backend/season/pass/mapping',
    method: 'post',
    data,
  })
}

export function delSeasonMappingPass(data) {
  return request({
    url: '/basic-backend/season/pass/mapping',
    method: 'delete',
    data,
  })
}

// season mapping block
export function getSeasonMappingBlockList(data) {
  return request({
    url: '/basic-backend/season/block/mapping/list',
    method: 'post',
    data,
  })
}

export function addSeasonMappingBlock(data) {
  return request({
    url: '/basic-backend/season/block/mapping',
    method: 'post',
    data,
  })
}

export function delSeasonMappingBlock(data) {
  return request({
    url: '/basic-backend/season/block/mapping',
    method: 'delete',
    data,
  })
}

// category mapping pass
export function getCategoryMappingPassList(data) {
  return request({
    url: '/basic-backend/category/pass/mapping/list',
    method: 'post',
    data,
  })
}

export function addCategoryMappingPass(data) {
  return request({
    url: '/basic-backend/category/pass/mapping',
    method: 'post',
    data,
  })
}

export function delCategoryMappingPass(data) {
  return request({
    url: '/basic-backend/category/pass/mapping',
    method: 'delete',
    data,
  })
}

// category mapping block
export function getCategoryMappingBlockList(data) {
  return request({
    url: '/basic-backend/category/block/mapping/list',
    method: 'post',
    data,
  })
}

export function addCategoryMappingBlock(data) {
  return request({
    url: '/basic-backend/category/block/mapping',
    method: 'post',
    data,
  })
}

export function delCategoryMappingBlock(data) {
  return request({
    url: '/basic-backend/category/block/mapping',
    method: 'delete',
    data,
  })
}

//获取所有系统枚举
export function getSystemList() {
  return request({
    url: `/basic-backend/boutique/system/list`,
    method: "get",
  });
}

export function editCategoryMappingBlock(data) {
  return request({
    url: '/basic-backend/category/pass/mapping/update',
    method: 'post',
    data,
  })
}

export function fileUpload() {
  return request({
    url: `/oss/file-upload-auth-sts`,
    method: 'GET'
  });
}

export function importCategory(data) {
  return request({
    url: '/basic-backend/category/pass/import',
    method: 'post',
    data,
  })
}

export function getSizeCleanList(data) {
  return request({
    url: '/sc-sku-standard-processing/cleanSize/mapImport/importRecords',
    method: 'post',
    data,
  })
}

// 第一步
export function importSizeMaps(data) {
  return request({
    url: '/sc-sku-standard-processing/cleanSize/mapImport/importSizeMaps',
    method: 'post',
    data,
  })
}

// 第二步
export function importCountrySizeMaps(data) {
  return request({
    url: '/sc-sku-standard-processing/cleanSize/mapImport/importCountrySizeMaps',
    method: 'post',
    data,
  })
}

// 第三步
export function importImSizeMaps(data) {
  return request({
    url: '/sc-sku-standard-processing/cleanSize/mapImport/importImSizeMaps',
    method: 'post',
    data,
  })
}

// product维度尺码导入
export function importProductSizeMaps(data) {
  return request({
    url: '/sc-sku-standard-processing/cleanSize/mapImport/import/product/size/maps',
    method: 'post',
    data,
  })
}

// 批量下载文件
export async function downdRemarkFile(params) {
  return request({
    url: `/sc-sku-standard-processing/cleanSize/mapImport/download/remark/file`,
    method: 'get',
    params,
    responseType: 'blob',
  });
}

export function getMappingVendorList() {
  return request({
    url: `/sc-basic-merchant-backend/vendor/brand/map/vendor`,
    method: "post",
  });
}

export function getVendorBrandList() {
  return request({
    url: `/sc-basic-merchant-backend/brand/list`,
    method: "get",
  });
}

export function getVendorBrandMappingList(data) {
  return request({
    url: '/sc-basic-merchant-backend/vendor/brand/map/list',
    method: 'post',
    data,
  })
}

export function addVendorBrandMapping(data) {
  return request({
    url: '/sc-basic-merchant-backend/vendor/brand/map/add',
    method: 'post',
    data,
  })
}

export function delVendorBrandMapping(data) {
  return request({
    url: '/sc-basic-merchant-backend/vendor/brand/map/del',
    method: 'post',
    data,
  })
}

export function getErrorCodeList() {
  return request({
    url: '/sc-basic-merchant-backend/product/manage/getErrorCodeList',
  })
}

export function getSKUDraftsProductList(data) {
  return request({
    url: '/sc-basic-merchant-backend/sku/draft/drafts/product/list',
    method: 'post',
    data,
  })
}

export function exportDraftsProduct(data) {
  return request({
    url: '/sc-basic-merchant-backend/sku/draft/drafts/product/export',
    method: 'post',
    data,
  })
}

export function draftsProductMarkTag(data) {
  return request({
    url: '/sc-basic-merchant-backend/product/manage/drafts/product/mark/tag',
    method: 'post',
    data,
  })
}

export function queryBoutiqueErrorByBoutiqueProductId(params) {
  return request({
    url: '/sc-basic-merchant-backend/product/manage/drafts/product/queryBoutiqueErrorByBoutiqueProductId',
    params,
  })
}

export function getSKUDraftProductInfo(boutiqueProductId) {
  return request({
    url: `/sc-basic-merchant-backend/sku/draft/drafts/product/info?boutiqueProductId=${boutiqueProductId}`,
  })
}

export function updateSKUDraft(data) {
  return request({
    url: '/sc-basic-merchant-backend/sku/draft/drafts/product/update',
    method: 'post',
    data,
  })
}

export function saveSKUDraft(data) {
  return request({
    url: '/sc-basic-merchant-backend/sku/draft/drafts/product/preservation',
    method: 'post',
    data,
  })
}


export function getBlackList(params) {
  return request({
    url: '/sc-basic-merchant-backend/api/brand/block/mapping/config/group/page',
    method: 'get',
    params,
  })
}

export function addBlack(data) {
  return request({
    url: '/sc-basic-merchant-backend/api/brand/block/mapping/config/add',
    method: 'post',
    data,
  })
}

export function deleteBlack(data) {
  return request({
    url: '/sc-basic-merchant-backend/api/brand/block/mapping/config/delete',
    method: 'post',
    data,
  })
}

export function deleteGroupBlack(data) {
  return request({
    url: '/sc-basic-merchant-backend/api/brand/block/mapping/config/group/delete',
    method: 'post',
    data,
  })
}

export function getMadeInStandardList(params) {
  return request({
    url: "/sc-basic-merchant-backend/madeIn/standard/list",
    method: "get",
    params,
  });
}

export function getMadeInPassList(data) {
  return request({
    url: "/sc-basic-merchant-backend/madeIn/pass/mapping/list",
    method: "post",
    data,
  });
}

export function saveMadeInPass(data) {
  return request({
    url: "/sc-basic-merchant-backend/madeIn/pass/mapping/save",
    method: "post",
    data,
  });
}

export function removeMadeInPass(data) {
  return request({
    url: "/sc-basic-merchant-backend/madeIn/pass/mapping/remove",
    method: "post",
    data,
  });
}

export function getMadeInBlockList(params) {
  return request({
    url: "/sc-basic-merchant-backend/madeIn/block/list",
    method: "get",
    params,
  });
}


export function saveMadeInBlock(data) {
  return request({
    url: "/sc-basic-merchant-backend/madeIn/block/save",
    method: "post",
    data,
  });
}

export function removeMadeInBlock(data) {
  return request({
    url: "/sc-basic-merchant-backend/madeIn/block/remove",
    method: "post",
    data,
  });
}

export function getFourCategoryList(params) {
  return request({
    url: "/basic-backend/category/list?flat=false",
    method: "get",
    params,
  });
}
